<!-- 
Shows the tabs for the levy collection setup page.
-->
<template>
  <v-card class="home">
    <v-tabs slider-color="primary" show-arrows >
      <v-tab key="levy-calculation" :to="getUrl('levy-calculation')">Levy calculation</v-tab>
      <v-tab key="levy-estimator" :to="getUrl('levy-estimator')">Levy estimator</v-tab>
      <v-tab key="notices" :to="getUrl('notices')">Notices</v-tab>
      <v-tab key="invoicing" :to="getUrl('invoicing')">Invoicing</v-tab>
    </v-tabs>
    <slot/>
    <initial-setup-dialog v-model="showInitialSetupDialog" :levy-collection="levyCollection" />
  </v-card>
</template>

<script>
import levyCollectionSetupMixins from "./mixins";
import InitialSetupDialog from "@/components/levy-collection-setup/InitialSetupDialog.vue";

export default {
  components: { InitialSetupDialog },
  mixins: [levyCollectionSetupMixins],
  methods: {
    getUrl(suffix) {
      return `/levy-collections/${this.levyCollectionId}/setup/${suffix}`;
    }
  }
};
</script>
